import { Component, Input, Output, EventEmitter } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-welcome-splash',
  standalone: true,
  templateUrl: './welcome-splash.component.html',
  styleUrls: ['./welcome-splash.component.scss'],
  imports: [CommonModule],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms ease-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('400ms ease-in', style({ opacity: 0 }))
      ])
    ]),
    trigger('zoomIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.92)' }),
        animate('600ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
      ])
    ]),
    trigger('fadeInDelayed', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('600ms 800ms ease-out', style({ opacity: 1 }))
      ])
    ])
  ]
})
export class WelcomeSplashComponent {
  @Input() logoSrc = 'assets/images/Fraud_Deflect_logo2-removebg.png';
  @Input() headline = 'WELCOME TO';
  @Input() titleLines: string[] = ['FRAUD', 'DEFLECT'];
  @Input() subtitle = 'Chargeback Solutions';
  @Input() autoDismissMs = 0;
  @Input() dismissMode: 'timeout' | 'afterSheen' = 'timeout';
  @Input() afterSheenDelayMs = 300;
  @Input() showContinueButton = true;
  @Input() buttonText = 'Enter';
  @Output() finish = new EventEmitter<void>();

  visible = true;

  get titleTop() { return this.titleLines[0] || ''; }
  get titleBottom() { return this.titleLines[1] || ''; }

  ngOnInit() {
    if (this.autoDismissMs > 0 && this.dismissMode === 'timeout') {
      setTimeout(() => {
        this.closeSplash()
      }, this.autoDismissMs);
    }
  }

  closeSplash() {
    this.visible = false;
    this.finish.emit();
  }

  onSheenEnd() {
    if (this.dismissMode === 'afterSheen') {
      setTimeout(() => this.closeSplash(), Math.max(0, this.afterSheenDelayMs));
    }
  }

  ngOnDestroy() { document.body.classList.remove('splash-open'); }

}





